import { COUNTRIES, STATES, CITIES } from "./action-types";

const initialState = {
  countries: [],
  states: [],
  cities: [],
  matchVenueCity: [],
};

export const location = (
  state = initialState,
  { type, payload = null }: any
): any => {
  switch (type) {
    case COUNTRIES:
      return {
        ...state,
        countries: payload,
      };
    case STATES:
      return {
        ...state,
        states: payload,
      };
    case CITIES:
      return {
        ...state,
        cities: payload,
      };
    default:
      return state;
  }
};
